let initialState = {};

export function RoleReducer(state = initialState, action) {
  const newValue = action.payload;

  switch (action.type) {
    // clear All

    case "CHANGE_ROLE":
      return {
        ...state,
        RoleId: newValue?.role?.roleId,
        roleName: newValue?.role?.roleName,
      };
    case "CHANGE_STATUS":
      return {
        ...state,
        Status: newValue.status,
      };

    default:
      return state;
  }
}
